import ApiClient from '../apiClient'
import { getUserId } from '../user'
import { DEFAULT_PAGE_SIZE } from '../../config'

const client = new ApiClient()

const getTaxAccounts = ({
  userId = getUserId(),
  page = 1,
  per_page = DEFAULT_PAGE_SIZE,
}) => {
  return client.get(`/users/${userId}/tax-accounts`, {
    params: { page, per_page },
  })
}

const taxAccountService = {
  getTaxAccounts,
}

export default taxAccountService
